import { useSyncExternalStore } from "react";

const DEFAULT_NARROW_WIDTH = 1024;

export function useIsNarrow(maxWidth = DEFAULT_NARROW_WIDTH) {
  const query = `(max-width: ${maxWidth}px)`;
  return useSyncExternalStore(
    (callback) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    () => window.matchMedia(query).matches,
    () => false
  );
}
